import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useOnboardUser = () => {
  const { call, isLoading } = useApiPrivateRequest();
  const onboardUser = async () => {
    await call("/users/onboard", "PUT");
  };
  return { onboardUser, isUserOnboarding: isLoading };
};
